import { useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  useFetchEmployerScheldules,
  useReSchedule,
} from "../../../../service/schedule.service";

const useReschedule = () => {
  type FormData = {
    date: Date | null;
    date2: Date | null;
  };
  const {
    watch,
    setValue,
    trigger,
    reset,
    formState: { isSubmitted },
  } = useForm<FormData>({
    defaultValues: {
      date: new Date(),
      date2: null,
    },
  });
  const {
    mutate: scheduleMutation,
    isLoading: scheduleLoading,
    data: scheduleData,
  } = useReSchedule();
  const { isLoading: fetchLoading, data: scheduleList } =
    useFetchEmployerScheldules();
  const [reschedule, setReschedule] = useState(false);
  const [selectedTimes, setSelectedtimes] = useState<any>([]);
  const [selectedTimes2, setSelectedtimes2] = useState<any>([]);
  const [isSubmitTimes, setIsSubmitTimes] = useState(false);
  const [anotherDay, setAnotherDay] = useState(false);
  const [isSubmitTimes2, setIsSubmitTimes2] = useState(false);
  const [copied, setCopied] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [error, setError] = useState({
    day1: "",
    day2: "",
    time1: "",
    time2: "",
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toggleAnotherDay = () => {
    setAnotherDay(!anotherDay);
  };
  const onModalClose = () => {
    reset();
    setReschedule(false);
    setIsSubmitTimes(false);
    setIsSubmitTimes2(false);
    setSelectedtimes([]);
    setSelectedtimes2([]);
    setAnotherDay(false);
    setSelectedItem(null);
    onClose();
  };
  useEffect(() => {
    if (selectedItem) {
      setSelectedtimes(selectedItem?.selectedTimes);
      setSelectedtimes2(selectedItem?.selectedTimes2);
      setAnotherDay(selectedItem?.anotherDay);
      setValue("date", new Date(selectedItem?.date));
      trigger("date");
      setValue(
        "date2",
        selectedItem?.date2 ? new Date(selectedItem?.date2) : null
      );
      trigger("date2");
    }
  }, [selectedItem]);

  const onChangeDate = (date: any) => {
    setError((prevData) => ({
      ...prevData,

      day1: "",
    }));
    setValue("date", date);
    trigger("date");
  };

  const handleOptionTimes = (option: any) => {
    setError((prevData) => ({
      ...prevData,
      time1: "",
    }));

    if (selectedTimes.includes(option)) {
      setSelectedtimes((prevSelectedOptions: any) =>
        prevSelectedOptions.filter((o: any) => o !== option)
      );
    } else {
      if (selectedTimes.length >= 3) {
        setError((prevData) => ({
          ...prevData,
          time1: "You can only select up to 3 time slots",
        }));
      } else {
        setSelectedtimes((prevSelectedOptions: any) => [
          ...prevSelectedOptions,
          option,
        ]);
      }
    }
  };
  const handleOptionTimes2 = (option: any) => {
    setError((prevData) => ({
      ...prevData,
      time2: "",
    }));

    if (selectedTimes2.includes(option)) {
      setSelectedtimes2((prevSelectedOptions: any) =>
        prevSelectedOptions.filter((o: any) => o !== option)
      );
    } else {
      if (selectedTimes2?.length >= 3) {
        setError((prevData) => ({
          ...prevData,
          time2: "You can only select up to 3 time slots",
        }));
      } else {
        setSelectedtimes2((prevSelectedOptions: any) => [
          ...prevSelectedOptions,
          option,
        ]);
      }
    }
  };
  useEffect(() => {
    if (copied) {
      const timeoutId = setTimeout(() => {
        setCopied(false);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [copied]);
  const onChangeDate2 = (date: any) => {
    setError((prevData) => ({
      ...prevData,
      day2: "",
    }));
    setValue("date2", date);
    trigger("date2");
  };
  const handleView = (data: any) => {
    setSelectedItem(data);
    onOpen();
  };
  const onSubmit = () => {
    let errors = {};

    if (selectedTimes.length === 0) {
      errors = {
        ...errors,
        time1: "Select at least one time slot",
      };
    }

    if (anotherDay && selectedTimes2.length === 0) {
      errors = {
        ...errors,
        time2: "Select at least one time slot",
      };
    }

    if (anotherDay && watch("date2") === null) {
      errors = {
        ...errors,
        day2: "Please Select a Date",
      };
    }

    if (Object.keys(errors).length > 0) {
      setError((prevData) => ({
        ...prevData,
        ...errors,
      }));
    } else {
      const data = {
        anotherDay,
        selectedTimes,
        selectedTimes2,
        date: watch("date"),
        date2: watch("date2"),
        interviewScheduleId: selectedItem?.interviewScheduleId,
      };

      scheduleMutation(data, {
        onSuccess: (res) => {
          onModalClose();
        },
      });
    }
  };

  return {
    isOpen,
    onOpen,
    onModalClose,
    onChangeDate,
    handleOptionTimes,
    selectedTimes,
    watch,
    isSubmitted,
    setReschedule,
    reschedule,
    isSubmitTimes,
    setIsSubmitTimes,
    setCopied,
    copied,
    onChangeDate2,
    handleOptionTimes2,
    isSubmitTimes2,
    selectedTimes2,
    toggleAnotherDay,
    anotherDay,
    setIsSubmitTimes2,
    scheduleList,
    handleView,
    selectedItem,
    onSubmit,
    scheduleLoading,
    fetchLoading,
    error,
  };
};

export default useReschedule;
